import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Image } from '@dotcom/crown-ui';
import { AddressTypes } from '../../global-types';
import { EnvelopeType, SelectedEnvelope } from '../../global-types/envelope';
import useAddressSelection from '../../hooks/use-address-selection';
import { ENVELOPES, MARKED_ENVELOPES } from './constants';
import styles from './styles.module.scss';
import { PreviewProps } from './types';

// EnvelopePreview Component to preview the selected envelope image in the envelope selection card
export const EnvelopePreview = ({ selectedEnvelope }: PreviewProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isRecipientAddress } = useAddressSelection();

  const isAddressView = pathname.includes('address');
  // find the selected envelope from the list of envelopes to display the correct image
  // when the user is on the envelope selection view
  const currentEnvelope = ENVELOPES.find((envelope: SelectedEnvelope) => envelope.key === selectedEnvelope);
  // this displays the correct envelope preview when user is on the address view
  const addressViewEnvelope = {
    [EnvelopeType.Return]: MARKED_ENVELOPES[EnvelopeType.Return][AddressTypes.SENDER],
    [EnvelopeType.ReturnRecipient]: isRecipientAddress
      ? MARKED_ENVELOPES[EnvelopeType.ReturnRecipient][AddressTypes.RECIPIENT]
      : MARKED_ENVELOPES[EnvelopeType.ReturnRecipient][AddressTypes.SENDER],
  };

  const preview = isAddressView ? addressViewEnvelope[String(selectedEnvelope)] : currentEnvelope;

  return (
    <div
      className={styles['envelope-preview']}
      data-testid={`envelope-preview${selectedEnvelope ? `-${selectedEnvelope}` : ''}${
        isAddressView ? '-address' : '-envelope'
      }`}
    >
      {preview && <Image key={preview.key} src={preview.image} alt={t(`envelopeView.${preview.key}EnvelopeLabel`)} />}
    </div>
  );
};
